import { buildApiUrl } from './api';
import { CreateMissionPayload, Mission, MissionCommandCenter, MissionEvent } from '../types/mission';

class MissionService {
  private async request<T>(endpoint: string, options?: RequestInit): Promise<T> {
    const token = localStorage.getItem('auth_token');

    const headers: HeadersInit = {
      'Content-Type': 'application/json',
      ...options?.headers,
    };

    if (token) {
      (headers as Record<string, string>).Authorization = `Bearer ${token}`;
    }

    const response = await fetch(buildApiUrl(endpoint), {
      ...options,
      headers,
    });

    if (!response.ok) {
      const error = await response.json().catch(() => ({ error: 'Erro desconhecido' }));
      throw new Error(error.error || error.message || `HTTP ${response.status}`);
    }

    if (response.status === 204) {
      return {} as T;
    }

    return response.json();
  }

  async listMissions(): Promise<Mission[]> {
    return this.request<Mission[]>('/missions');
  }

  async createMission(payload: CreateMissionPayload): Promise<Mission> {
    return this.request<Mission>('/missions', {
      method: 'POST',
      body: JSON.stringify(payload),
    });
  }

  async getMissionCommandCenter(id: string): Promise<MissionCommandCenter> {
    return this.request<MissionCommandCenter>(`/missions/${id}/command-center`);
  }

  async getMissionTimeline(id: string): Promise<MissionEvent[]> {
    return this.request<MissionEvent[]>(`/missions/${id}/timeline`);
  }

  async approveMission(id: string, approvalId: string, reason?: string): Promise<{ success: boolean }> {
    return this.request<{ success: boolean }>(`/missions/${id}/approve`, {
      method: 'POST',
      body: JSON.stringify({ approvalId, reason }),
    });
  }

  async rejectMission(id: string, approvalId: string, reason?: string): Promise<{ success: boolean }> {
    return this.request<{ success: boolean }>(`/missions/${id}/reject`, {
      method: 'POST',
      body: JSON.stringify({ approvalId, reason }),
    });
  }
}

export const missionService = new MissionService();
